import React, { lazy, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { setShouldUpdateUserWinnerList } from 'client/redux/modules/flags';
import { lotteryOpenPathParams } from 'config/promoLotteryTypes';

import AnimationContainer from 'client/components/Lottery/AnimationContainer';

const General = lazy(() =>
    import(/* webpackChunkName: "client_lottery_general" */ 'client/components/Lottery/General')
);
const ScratchCard = lazy(() =>
    import(/* webpackChunkName: "Scratch_Card" */ 'client/components/Lottery/ScratchCard')
);
const Winwheel = lazy(() =>
    import(/* webpackChunkName: "client_lottery_winwheel" */ 'client/components/Lottery/Winwheel')
);
const PokeGame = lazy(() =>
    import(/* webpackChunkName: "PokeGame" */ 'client/components/Lottery/PokeGame')
);
const RedEnvelopeRain = lazy(() =>
    import(
        /* webpackChunkName: "client_red_envelope_rain" */ 'client/components/Lottery/RedEnvelopeRain'
    )
);
const Slots = lazy(() => import(/* webpackChunkName: "" */ 'client/components/Lottery/Slots'));
const PickThePrize = lazy(() =>
    import(/* webpackChunkName: "" */ 'client/components/Lottery/PickThePrize')
);

export default function Lottery({ match }) {
    const dispatch = useDispatch();

    useEffect(() => {
        return () => dispatch(setShouldUpdateUserWinnerList());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Switch>
            <Route
                path={`${match.path}/${lotteryOpenPathParams.GENERAL}/:prizeUUID/:entriesUUID`}
                component={General}
            />
            <Route
                path={`${match.path}/${lotteryOpenPathParams.SCRATCH_CARD}/:prizeUUID/:entriesUUID`}
                render={withAnimationProps(ScratchCard)}
            />
            <Route
                path={`${match.path}/${lotteryOpenPathParams.WIN_WHEEL}/:prizeUUID/:entriesUUID`}
                render={withAnimationProps(Winwheel)}
            />
            <Route
                path={`${match.path}/${lotteryOpenPathParams.POKE_GAME}/:prizeUUID/:entriesUUID`}
                render={withAnimationProps(PokeGame)}
            />
            <Route
                path={`${match.path}/${lotteryOpenPathParams.RED_ENVELOPE_RAIN}/:prizeUUID/:entriesUUID`}
                render={withAnimationProps(RedEnvelopeRain)}
            />
            <Route
                path={`${match.path}/${lotteryOpenPathParams.SLOTS}/:prizeUUID/:entriesUUID`}
                render={withAnimationProps(Slots)}
            />
            <Route
                path={`${match.path}/${lotteryOpenPathParams.PICK_THE_PRIZE}/:entriesUUID`}
                component={PickThePrize}
            />
        </Switch>
    );
}

const withAnimationProps = Comp => {
    return routeProps => (
        <AnimationContainer {...routeProps}>{props => <Comp {...props} />}</AnimationContainer>
    );
};
